<template>
  <div>
    <Loader v-if="loading" />
    <div v-else class="app-main-layout">
      <Navbar @click="toggler" @closeMenu="closeSide" />

      <Sidebar v-model="isOpen" :key="locale" @close="closeSide" />

      <main ref="main" class="app-content" :class="{full: need}" @click="closeSide">
        <div class="app-page">
          <router-view />
        </div>
      </main>

      <div class="fixed-action-btn" @click.prevent="addClick">
        <router-link
          class="btn-floating btn-large light-blue waves-effect waves-light"
          to="/record"
        >
          <i class="large material-icons">add</i>
        </router-link>
      </div>
    </div>
  </div>
</template>

<style>
body.lock {
  overflow: hidden !important;
}
.app-content {
  min-height: 100vh !important;
}
</style>

<script>
import Navbar from "@/components/app/Navbar";
import Sidebar from "@/components/app/Sidebar";
import messages from "@/utils/messages";
import localizeFilter from "@/filters/localize.filter";

export default {
  name: "main-layout",
  data: () => ({
    isOpen: true,
    loading: true,
    width: null,
    need: false
  }),
  async mounted() {
    if (messages[this.$route.query.message]) {
      this.$message(localizeFilter(messages[this.$route.query.message]));
    }

    if (!this.$store.getters.info.bill || !this.$store.getters.info.name) {
      await this.$store.dispatch("fetchInfo");
    }

    this.width = window.innerWidth;

    this.isOpen = false;

    this.loading = false;
  },
  components: {
    Sidebar,
    Navbar
  },
  computed: {
    error() {
      return this.$store.getters.error;
    },
    locale() {
      return this.$store.getters.info.locale;
    }
  },
  watch: {
    isOpen() {
      if (this.width <= 830) {
        if (this.isOpen === true) {
          document.body.classList.add("lock");
        }
        if (this.isOpen === false) {
          document.body.classList.remove("lock");
        }
      }
    },
    error(fbError) {
      this.$error(
        localizeFilter(messages[fbError.code]) || "Что то пошло не так..."
      );
    },
    width() {
      if (this.width <= 830) {
        this.isOpen = false;
        this.need = true;
      } else if (this.width > 830) {
        this.isOpen = true;
        this.need = false;
      }
    }
  },
  methods: {
    updateWidth() {
      this.width = window.innerWidth;
    },
    closeSide() {
      if (this.width <= 830) {
        this.isOpen = false;
      }
    },
    toggler() {
      if (this.width <= 830) {
        this.isOpen = !this.isOpen;
        this.need = true;
      } else if (this.width > 830) {
        this.isOpen = !this.isOpen;
        this.need = !this.need;
      }
    },
    addClick() {
      if (this.width <= 830) {
        this.isOpen = false;
      }
    }
  },
  created() {
    window.addEventListener("resize", this.updateWidth);
  }
};
</script>